:host {
  @apply block;
}

a {
  &:hover {
    .scale-100 {
      @apply scale-[1.2];
    }
  }
}

::slotted(svg) {
  @apply w-full h-full box-border overflow-hidden;
  fill: currentColor;
}

::slotted(:not(svg)) {
  @apply  max-w-[28px] max-h-[28px];
}

::slotted([slot=label-icon]) {
  @apply relative inline-block top-[1px] text-berry ml-[5px];
}
